<template>
  <v-autocomplete
    v-model="STATUS_PRODUTOS_SELECIONADOS"
    label="Status produto"
    :items="status_produto"
    item-value="id"
    item-text="descricao"
    hide-details
    clearable
    outlined
    multiple
    small-chips
  >
    <template #prepend-item>
      <SysItemListaSelecionaTudo
        v-model="STATUS_PRODUTOS_SELECIONADOS"
        :itens="status_produto"
        valor-chave="id"
      />
      <v-divider />
    </template>

    <template #selection="{item}">
      <TextoOutrosFiltrosSelecionadosAutocomplete :filtros="STATUS_PRODUTOS_SELECIONADOS" :item="item" retornar_texto_completo />
    </template>
  </v-autocomplete>
</template>

<script>
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";

export default {
  name: "SysStatusProduto",
  components: {TextoOutrosFiltrosSelecionadosAutocomplete, SysItemListaSelecionaTudo},
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: ["modelValue"],
  data: () => ({
    status_produto: [
      {id: '1. Excesso', descricao: '1. Excesso'},
      {id: '2. Adequado', descricao: '2. Adequado'},
      {id: '3. Baixa Exposição a Ruptura', descricao: '3. Baixa Exposição a Ruptura'},
      {id: '4. Elevada Exposição a Ruptura', descricao: '4. Elevada Exposição a Ruptura'},
      {id: '5. Em Ruptura', descricao: '5. Em Ruptura'},
    ]
  }),
  computed: {
    STATUS_PRODUTOS_SELECIONADOS: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor)
      }
    }
  }
}
</script>

<style scoped>

</style>
